import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ProcoreService {

	headerStatus = '';

	constructor(
		private http: HttpClient
	) { }

	getUserInfo(companyId: number, authCode: string, isSandbox: boolean) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('authCode', authCode);
		params = params.set('isSandbox', isSandbox);

		const requestUrl = `${environment.serviceUrl}/procore/user-info`;

		return this.http.get<any>(requestUrl, { headers, params });
	}

	getProjects(companyId: string, isSandbox: boolean, username: string, procoreUserId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);
		params = params.set('isSandbox', isSandbox);

		const requestUrl = `${environment.serviceUrl}/procore/projects`;

		return this.http.get<any[]>(requestUrl, { headers, params });
	}

	getPrimeContractData(companyId: string, projectId: string, isSandbox: boolean, username: string, procoreUserId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);
		params = params.set('isSandbox', isSandbox);

		const requestUrl = `${environment.serviceUrl}/procore/projects/prime-contracts`;

		return this.http.get<any>(requestUrl, { headers, params });
	}

	getCommitmentData(companyId: string, projectId: string, isSandbox: boolean, username: string, procoreUserId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);
		params = params.set('isSandbox', isSandbox);

		const requestUrl = `${environment.serviceUrl}/procore/projects/commitments`;

		return this.http.get<any>(requestUrl, { headers, params });
	}

	deleteProjectAsset(companyId: string, projectId: string, itemId: string, itemType: string, isSandbox: boolean, username: string, procoreUserId: string) {
		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);
		params = params.set('itemId', itemId);
		params = params.set('itemType', itemType);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);
		params = params.set('isSandbox', isSandbox);

		const requestUrl = `${environment.serviceUrl}/procore/projects/asset`;

		return this.http.delete(requestUrl, { params, responseType: 'text' });
	}

	updateProjectAssetStatus(status: string, companyId: string, projectId: string, itemId: string, itemType: string, isSandbox: boolean, username: string, procoreUserId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('status', status);
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);
		params = params.set('itemId', itemId);
		params = params.set('itemType', itemType);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);
		params = params.set('isSandbox', isSandbox);

		const requestUrl = `${environment.serviceUrl}/procore/projects/asset/status`;

		return this.http.patch<any>(requestUrl, null, { params, headers });
	}

	generatePrimeContractAssets(primeContracts: number, primeContractChangeOrders: number, primeContractChangeOrderBatches: number, primeContractPaymentApplications: number, companyId: string, projectId: string, deleteExistingAssets: boolean, isSandbox: boolean, username: string, procoreUserId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);
		params = params.set('deleteExistingAssets', deleteExistingAssets);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);
		params = params.set('isSandbox', isSandbox);
		params = params.set('primeContracts', primeContracts);
		params = params.set('primeContractChangeOrders', primeContractChangeOrders);
		params = params.set('primeContractChangeOrderBatches', primeContractChangeOrderBatches);
		params = params.set('primeContractPaymentApplications', primeContractPaymentApplications);

		const requestUrl = `${environment.serviceUrl}/procore/projects/prime-contracts/generate`;

		return this.http.post(requestUrl, null, { headers, params, responseType: 'text' });
	}

	generateCommitmentAssets(commitmentPurchaseOrders: number, commitmentSubcontracts: number, commitmentChangeOrders: number, commitmentChangeOrderBatches: number, commitmentRequisitions: number, companyId: string, projectId: string, deleteExistingAssets: boolean, isSandbox: boolean, username: string, procoreUserId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);
		params = params.set('deleteExistingAssets', deleteExistingAssets);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);
		params = params.set('isSandbox', isSandbox);
		params = params.set('commitmentPurchaseOrders', commitmentPurchaseOrders);
		params = params.set('commitmentSubcontracts', commitmentSubcontracts);
		params = params.set('commitmentChangeOrders', commitmentChangeOrders);
		params = params.set('commitmentChangeOrderBatches', commitmentChangeOrderBatches);
		params = params.set('commitmentRequisitions', commitmentRequisitions);

		const requestUrl = `${environment.serviceUrl}/procore/projects/commitments/generate`;

		return this.http.post(requestUrl, null, { headers, params, responseType: 'text' });
	}

	exportAssetStart(companyId: string, projectId: string, itemId: string, itemType: string, username: string, procoreUserId: string, isSandbox: boolean) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);
		params = params.set('itemId', itemId);
		params = params.set('itemType', itemType);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);
		params = params.set('isSandbox', isSandbox);

		const requestUrl = `${environment.serviceUrl}/procore/projects/asset/export/start`;

		return this.http.post(requestUrl, null, { headers, params, responseType: 'text' });
	}

	exportAssetToDropbox(url: string, companyId: string, projectId: string, itemId: string, itemType: string, username: string, procoreUserId: string, isSandbox: boolean) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);
		params = params.set('itemId', itemId);
		params = params.set('itemType', itemType);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);
		params = params.set('isSandbox', isSandbox);

		let body = { 'url': url };

		const requestUrl = `${environment.serviceUrl}/procore/projects/asset/export/dropbox`;

		return this.http.post(requestUrl, body, { params, responseType: 'text', observe: 'response' });
	}

	exportAssetAttachmentToDropbox(url: string, companyId: string, projectId: string, itemId: string, itemType: string, username: string, procoreUserId: string, isSandbox: boolean) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);
		params = params.set('itemId', itemId);
		params = params.set('itemType', itemType);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);
		params = params.set('isSandbox', isSandbox);

		let body = { 'url': url };

		const requestUrl = `${environment.serviceUrl}/procore/projects/asset/attachment/export/dropbox`;

		return this.http.post(requestUrl, body, { params, responseType: 'text', observe: 'response' });
	}

	// generateProjectAssets(primeContracts: number, primeContractChangeOrders: number, primeContractChangeOrderBatches: number, primeContractPaymentApplications: number, commitmentSubcontracts: number, commitmentPurchaseOrders: number, commitmentChangeOrders: number, commitmentRequisitions: number, rfis: number, submittals: number, incidents: number, observations: number, punchList: number, meetings: number, timesheets: number, companyId: string, projectId: string, deleteExistingAssets: boolean, isSandbox: boolean, username: string, procoreUserId: string) {
	// 	let headers = new HttpHeaders();
	// 	headers = headers.set('Content-Type', 'application/json');

	// 	let params = new HttpParams();
	// 	params = params.set('companyId', companyId);
	// 	params = params.set('projectId', projectId);
	// 	params = params.set('deleteExistingAssets', deleteExistingAssets);
	// 	params = params.set('username', username);
	// 	params = params.set('procoreUserId', procoreUserId);
	// 	params = params.set('isSandbox', isSandbox);
	// 	params = params.set('primeContracts', primeContracts);
	// 	params = params.set('primeContractChangeOrders', primeContractChangeOrders);
	// 	params = params.set('primeContractChangeOrderBatches', primeContractChangeOrderBatches);
	// 	params = params.set('primeContractPaymentApplications', primeContractPaymentApplications);
	// 	params = params.set('commitmentSubcontracts', commitmentSubcontracts);
	// 	params = params.set('commitmentPurchaseOrders', commitmentPurchaseOrders);
	// 	params = params.set('commitmentChangeOrders', commitmentChangeOrders);
	// 	params = params.set('commitmentRequisitions', commitmentRequisitions);
	// 	params = params.set('rfis', rfis);
	// 	params = params.set('submittals', submittals);
	// 	params = params.set('incidents', incidents);
	// 	params = params.set('observations', observations);
	// 	params = params.set('punchList', punchList);
	// 	params = params.set('meetings', meetings);
	// 	params = params.set('timesheets', timesheets);

	// 	const requestUrl = `${environment.serviceUrl}/procore/projects/generate-assets`;

	// 	return this.http.post(requestUrl, null, { headers, params, responseType: 'text' });
	// }
}
